import script from "./ConfluenceMacroSettingsModalFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfluenceMacroSettingsModalFooter.vue?vue&type=script&setup=true&lang=js"

import "./ConfluenceMacroSettingsModalFooter.vue?vue&type=style&index=0&id=04e99507&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e99507"]])

export default __exports__